import React, { useState } from 'react';

import { usePatchScheduleExpectationCycle } from '@/hooks/useScheduleExpectationCycles/useScheduleExpectationCycles';
import {
  PatchScheduleExpectationCycleData,
  ScheduleExpectationCycle
} from '@/types/scheduleExpectation';
import { Modal, Textarea } from '@/ui';

export const useSilenceScheduleExpectationCycleButton = (
  scheduleExpectationCycle: ScheduleExpectationCycle
): { buttonProps: { disabled: boolean; onClick: () => void }; modal: React.ReactNode } => {
  const { silenced_at, schedule_expectation_cycle_id, phase_id } = scheduleExpectationCycle;
  const isSilenced = silenced_at !== null;
  const action = isSilenced ? 'unsilence' : 'silence';

  const patchCycle = usePatchScheduleExpectationCycle(phase_id);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [note, setNote] = useState('');

  const handleNoteChange: React.ChangeEventHandler = (e) => {
    setNote((e.target as unknown as { value: string }).value);
  };

  const handleConfirm = () => {
    const data: PatchScheduleExpectationCycleData = {
      silenced_at: isSilenced ? null : new Date().toISOString()
    };
    if (note.trim()) {
      data.note = note.trim();
    }
    patchCycle.mutate({ id: schedule_expectation_cycle_id, data });
    setIsModalOpen(false);
    setNote('');
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setNote('');
  };

  const buttonProps = {
    disabled: patchCycle.isPending,
    onClick: () => setIsModalOpen(true),
    children: isSilenced ? 'Unsilence cycle' : 'Silence cycle'
  };

  const modal = (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
      title={`Are you sure you want to ${action} this cycle?`}
      primaryAction={{ label: 'Confirm', onClick: handleConfirm }}
      secondaryAction={{ label: 'Cancel', onClick: handleClose }}>
      {!isSilenced && (
        <Textarea
          id="silence-note"
          labelText="Note (optional)"
          name="note"
          value={note}
          onChange={handleNoteChange}
          placeholder="Add a note..."
          rows={3}
        />
      )}
    </Modal>
  );

  return { buttonProps, modal };
};
